var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c(_vm.h2 ? 'h2' : 'h1',{tag:"Component",class:{
    'h4': !_vm.h2,
    'h5': _vm.h2,
    'heading-badge': _vm.targetPlan
  }},[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.targetPlan)?_c('UpgradeBadge',{staticClass:"ml-2",attrs:{"targetPlan":_vm.targetPlan,"noFreeUsers":_vm.noFreeUsers,"tryForFree":_vm.tryForFree}}):_vm._e()],1),(_vm.subTitle)?_c('p',{staticClass:"font-weight-normal mb-0"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }